export const appPageTransition = {"name":"fade","mode":"out-in"}

export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"author","content":"partner-s"},{"name":"publisher","content":"partner-s"},{"name":"description","content":"기업 금융 자산 통합 관리 & 현금흐름 관리 솔루션 파트너스는 기업 재무 관리를 혁신적으로 변화시킵니다. 파트너스 비즈에서는 사업자번호를 통해 사업자 등록 정보를 확인할 수 있습니다. 손쉽게 거래처 등의 정보를 상호명, 법인등록번호 등으로 찾아보세요."},{"name":"format-detection","content":"telephone=no"},{"name":"keywords","content":"사업자등록번호조회,사업자정보,기업정보,사업자등록번호검색,사업자정보검색,사업자정보확인,법인등록번호조회,상호조회,사업자번호,법인등록번호,홈택스,국세청"},{"name":"naver-site-verification","content":"6ee41841e656827feced529bc927cb732db8ac5e"},{"property":"og:title","content":"사업자번호 간편 정보 조회 :: 파트너스 비즈"},{"property":"og:description","content":"기업 금융 자산 통합 관리 & 현금흐름 관리 솔루션 파트너스는 기업 재무 관리를 혁신적으로 변화시킵니다.\n파트너스 비즈에서는 사업자번호를 통해 사업자 등록 정보를 확인할 수 있습니다.\n손쉽게 거래처 등의 정보를 상호명, 법인등록번호 등으로 찾아보세요."},{"property":"og:image","content":"/images/og_biz_partners_image.png"}],"link":[{"rel":"canonical","href":"https://biz.partner-s.co"},{"rel":"apple-touch-icon","sizes":"57x57","href":"https://cdn.partner-s.co/favicon/apple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"https://cdn.partner-s.co/favicon/apple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"https://cdn.partner-s.co/favicon/apple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"https://cdn.partner-s.co/favicon/apple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"https://cdn.partner-s.co/favicon/apple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"https://cdn.partner-s.co/favicon/apple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"https://cdn.partner-s.co/favicon/apple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"https://cdn.partner-s.co/favicon/apple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https://cdn.partner-s.co/favicon/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"https://cdn.partner-s.co/favicon/android-icon-192x192.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://cdn.partner-s.co/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"https://cdn.partner-s.co/favicon/favicon-96x96.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://cdn.partner-s.co/favicon/favicon-16x16.png"}],"style":[],"script":[],"noscript":[],"title":"사업자번호 간편 정보 조회 :: 파트너스 비즈","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000